import React from 'react';
import PeptideCalculatorTemplate from '../components/PeptideCalculatorTemplate';
import { PEPTIDE_DATA } from '../data/peptideCalculatorData';

const RetatrutideCalculator = () => {
  return <PeptideCalculatorTemplate peptideData={PEPTIDE_DATA.retatrutide} />;
};

export default RetatrutideCalculator;
